"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _tag = _interopRequireDefault(require("@amzn/meridian-tokens/component/tag"));
var _theme = require("../theme");
var _buttonReset = _interopRequireDefault(require("./../_styles/button-reset"));
var _token = require("./../_utils/token");
var _useFocus2 = _interopRequireDefault(require("../_use-focus"));
var _text = _interopRequireDefault(require("./../_styles/text"));
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _indicator = _interopRequireDefault(require("./indicator"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Styles
 */

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
    children = _ref.children,
    focus = _ref.focus;
  return (0, _css.css)(_buttonReset["default"], (0, _text["default"])(t), {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: t("height"),
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    outline: "none",
    "& > div": (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      offset: t("focusOutlineOffset"),
      borderRadius: t("borderRadius"),
      borderWidth: t("borderWidth")
    })
  }, children === undefined ? {
    width: t("height"),
    "& > div": {
      borderRadius: t("borderCompactRadius"),
      borderWidth: t("borderCompactWidth"),
      borderStyle: "solid",
      borderColor: t("borderColorCompact"),
      boxSizing: "border-box"
    }
  } : {
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderStyle: "solid",
    borderColor: t("borderColorStatus", type),
    paddingInlineStart: t("spacingInsetStatusStart"),
    paddingInlineEnd: t("spacingInsetStatusEnd")
  });
}, ["type", "children", "focus"]);

/**
 * Component
 */
var StatusTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  var _useFocus = (0, _useFocus2["default"])(),
    focus = _useFocus.focus,
    focusTrigger = _useFocus.focusTrigger,
    focusProps = _useFocus.focusProps;
  var compact = typeof props.children === "undefined" ? true : false;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, _objectSpread({
      focus: focus && focusTrigger === "keyboard"
    }, props)),
    ref: ref,
    "aria-label": props["aria-label"],
    tabIndex: props.tabIndex
  }, passThroughProps, focusProps), /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
    type: props.type,
    compact: compact
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.children));
});
StatusTag.displayName = "StatusTag";
StatusTag.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": _propTypes["default"].string,
  children: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
StatusTag.defaultProps = {
  type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;